module.exports = __webpack_public_path__ + "static/CircularPro-BlackItalic.beec8a46.woff2";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-BlackItalic.woff2
// module id = 717
// module chunks = 168707334958949